module.exports = __webpack_public_path__ + "static/img/adminImg1.e2255e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adminImg1.png
// module id = U+Vs
// module chunks = 2